import {
  Card,
  GameInfo,
  InPlayRoomWsResponse,
} from '@/screens/authenticated/types';
import { SendMessage } from '@/screens/authenticated/use-websocket';
import { CardPosition, CardsWithLayout } from '../cards-with-layout';
import React, { FC } from 'react';
import { Playground } from './playground';
import { Box, styled } from '@mui/material';
import { ConfirmCardBox } from './confirm-card';
import {
  isHandLocked,
  isOffSuitBlocked,
} from '@/screens/authenticated/in-play/use-play-card';

interface GamePlayProps {
  readonly inPlayResponse: InPlayRoomWsResponse | null;
  readonly sendMessage: SendMessage;
  readonly showPlayGround: boolean;
  readonly selectedCard: {
    card: Card;
    pos: CardPosition;
  } | null;
  readonly gameInfo: GameInfo | null;
  readonly setSelectedCard: React.Dispatch<
    React.SetStateAction<{
      card: Card;
      pos: CardPosition;
    } | null>
  >;
  readonly userDeck: Card[];
  readonly onClickCard?:
    | ((card: Card, pos: CardPosition) => () => void)
    | undefined;
  readonly userID: string;
  readonly lockDrag?: boolean | undefined;
  readonly isLandscapeMode: boolean;
}

export const RenderGamePlay: FC<GamePlayProps> = ({
  inPlayResponse,
  sendMessage,
  showPlayGround,
  selectedCard,
  gameInfo,
  setSelectedCard,
  userDeck,
  onClickCard,
  userID,
  lockDrag,
  isLandscapeMode,
}) => {
  return (
    <>
      {inPlayResponse && showPlayGround && (
        <Playground
          inPlayWS={inPlayResponse}
          sendMessage={sendMessage}
          isVerticalMode={!isLandscapeMode}
        />
      )}
      {selectedCard && gameInfo?.room?.isFull && (
        <ConfirmCardBox
          {...{
            card: selectedCard?.card,
            pos: selectedCard.pos,
            setSelectedCard,
          }}
        />
      )}
      <InPlayPageWrapper isVerticalMode={!isLandscapeMode}>
        {userDeck && (
          <CardsWithLayout
            {...{
              cards: userDeck.map(
                addCardDisableStatus(
                  // gameInfo is inPlayResponse.gameInfo for both tables.
                  isHandLocked(inPlayResponse?.gameInfo ?? gameInfo, userID),
                  inPlayResponse?.gameInfo?.inPlayCards?.[0]?.suite,
                  userDeck
                )
              ),
              onClickCard,
              selectedCard: selectedCard?.card,
              lockDrag,
            }}
          />
        )}
      </InPlayPageWrapper>
    </>
  );
};

const InPlayPageWrapper = styled(Box, {
  shouldForwardProp: prop => prop !== 'isVerticalMode',
})<{ isVerticalMode: boolean }>(({ theme, isVerticalMode }) => ({
  position: 'absolute',
  bottom: `calc(${isVerticalMode ? '40px' : '20px'} + env(safe-area-inset-bottom))`,
  left: 0,
  marginBottom: theme.spacing(2),
  width: '100%',
  maxWidth: '100%',
}));

function addCardDisableStatus(
  disableAll: boolean,
  firstCardSuite?: Card['suite'],
  userDeck?: Card[]
) {
  return (card: Card) => {
    // Same rules usePlayCard enforces before submitting a click.
    return {
      ...card,
      disabled: disableAll || isOffSuitBlocked(card, firstCardSuite, userDeck),
    };
  };
}
